import React from "react";
import MapboxHelpTooltip from "../component/MapboxHelpTooltip.jsx";
import { LAYER_PROPS } from "./layer_const.js";
import InputWithJson from "../component/InputWithJson.jsx";
import Select from '../../../../common/Select.jsx'

const SymbolLayout = ({updateField, layerField, index}) => {
    const textField = LAYER_PROPS.symbol.layout['text-field']
    const layout = (layerField.symbol || {}).layout || {}
    return (
        <>
            {!layout.useTextFieldJson &&
                <label className="col-xs-9 col-md-9">
                    {textField.title}
                    <MapboxHelpTooltip description={textField.description} />
                    <input 
                        type="text" 
                        className="form-control" 
                        name={`layerFields.${index}.symbol.layout.text-field`}
                        value={layout['text-field']} 
                        onChange={(e) => updateField(`layerFields.${index}.symbol.layout.text-field`, e.target.value)} 
                    />
                </label>
            }
            <InputWithJson
                withInput={true}
                toggleSetting={{
                    useJson: layout.useTextFieldJson,
                    setUseJson: (value) => updateField(`layerFields.${index}.symbol.layout.useTextFieldJson`, value),
                    name: `layerFields.${index}.symbol.layout.useTextFieldJson`
                }}
                jsonInputSetting={{
                    value: layout['text-field'],
                    updateJsonValue: (value) => updateField(`layerFields.${index}.symbol.layout.text-field`, value),
                    label: textField.title,
                    description: textField.description
                }}
            />
        </>
    )
}

const CircleLayout = ({updateField, layerField, index}) => {
    return (
        <>
        </>
    )
}

const HeatmapLayout = ({updateField, layerField, index}) => {
    return (
        <>
        </>
    )
}

const RasterLayout = ({updateField, layerField, index}) => {
    return (
        <>
        </>
    )
}

const SmartmeIconLayout = ({updateField, layerField, index}) => {
    const layoutDefault = LAYER_PROPS.customSmartmeIcon.layout
    const layout = (layerField.customSmartmeIcon || {}).layout || {}
    return (
        <>
            <label className="col-xs-6 col-md-6">
                {layoutDefault["type"].title}
                <MapboxHelpTooltip description={layoutDefault["type"].description} />
                <Select
                    value={layout["type"]}
                    options={layoutDefault["type"].options}
                    onChange={(v) => updateField(`layerFields.${index}.customSmartmeIcon.layout.type`, v)}
                />
            </label>
            <label className="col-xs-6 col-md-6">
                {layoutDefault["status"].title}
                <MapboxHelpTooltip description={layoutDefault["status"].description} />
                <Select
                    value={layout["status"]}
                    options={layoutDefault["status"].options}
                    onChange={(v) => updateField(`layerFields.${index}.customSmartmeIcon.layout.status`, v)}
                />
            </label>
            <label className="col-xs-6 col-md-6">
                {layoutDefault["info1"].title}
                <MapboxHelpTooltip description={layoutDefault["info1"].description} />
                <input
                    type="text"
                    className="form-control"
                    value={layout["info1"]}
                    onChange={(e) => updateField(`layerFields.${index}.customSmartmeIcon.layout.info1`, e.target.value)}
                />
            </label>
            <label className='col-xs-6 cold-md-6'>
                {layoutDefault["unit"].title}
                <MapboxHelpTooltip description={layoutDefault["unit"].description} />
                <input
                    type="text"
                    className="form-control"
                    value={layout["unit"]}
                    onChange={(e) => updateField(`layerFields.${index}.customSmartmeIcon.layout.unit`, e.target.value)}
                />
            </label>
            <label className="col-xs-6 col-md-6">
                {layoutDefault["info2"].title}
                <MapboxHelpTooltip description={layoutDefault["info2"].description} />
                <input
                    type="text"
                    className="form-control"
                    value={layout["info2"]}
                    onChange={(e) => updateField(`layerFields.${index}.customSmartmeIcon.layout.info2`, e.target.value)}
                />
            </label>
            <label className="col-xs-6 col-md-6">
                {layoutDefault["info3"].title}
                <MapboxHelpTooltip description={layoutDefault["info3"].description} />
                <input
                    type="text"
                    className="form-control"
                    value={layout["info3"]}
                    onChange={(e) => updateField(`layerFields.${index}.customSmartmeIcon.layout.info3`, e.target.value)}
                />
            </label>
        </>
    )
}

const LAYOUT_TYPE_MAPPING = {
    symbol: (updateField, layerField, index) => {return <SymbolLayout updateField={updateField} layerField={layerField} index={index} />},
    circle: (updateField, layerField, index) => {return <CircleLayout updateField={updateField} layerField={layerField} index={index} />},
    heatmap: (updateField, layerField, index) => {return <HeatmapLayout updateField={updateField} layerField={layerField} index={index} />},
    raster: (updateField, layerField, index) => {return <RasterLayout updateField={updateField} layerField={layerField} index={index} />},
    customSmartmeIcon: (updateField, layerField, index) => {return <SmartmeIconLayout updateField={updateField} layerField={layerField} index={index} />}
}

const LayerLayout = ({layerField, updateField, index}) => {
    return LAYOUT_TYPE_MAPPING[layerField['type']](updateField, layerField, index) || null 

}

export default LayerLayout